'use strict';

var UserFareExclusionRulesTransformerFactory = function UserFareExclusionRulesTransformerFactory(DataTransformer, momentService) {
  function UserFareExclusionRulesTransformer() {
    DataTransformer.call(this);
    this.sourceType = 'user-fare-exclusion-rules-mode';
  }
  UserFareExclusionRulesTransformer.prototype = Object.create(DataTransformer.prototype);
  UserFareExclusionRulesTransformer.constructor = UserFareExclusionRulesTransformer;
  UserFareExclusionRulesTransformer.prototype.canTransform = function (sourceType) {
    return this.sourceType === sourceType;
  };
  UserFareExclusionRulesTransformer.prototype.isCacheable = function () {
    return false;
  };
  UserFareExclusionRulesTransformer.prototype.getCacheKey = function () {
    return this.sourceType;
  };
  UserFareExclusionRulesTransformer.prototype.transform = function (data) {
    var exclusionRules = data.domain.fareExclusionRulesList;
    var result = [];
    for (var i = 0; i < exclusionRules.length; i++) {
      var exclusionRule = exclusionRules[i];
      var exclusion = {
        foCarrier: exclusionRule.carrier,
        fareSource: exclusionRule.fareSource,
        fareTariffNumber: exclusionRule.fareTariffNumber,
        foCabin: exclusionRule.cabin,
        category: exclusionRule.category,
        foRbd: exclusionRule.rbd,
        fareBasisCode: exclusionRule.fareBasisCode,
        origin: exclusionRule.origin,
        destination: exclusionRule.destination,
        foOriginCountry: exclusionRule.originCountry,
        foDestCountry: exclusionRule.destinationCountry,
        travelFromDate: momentService.of(exclusionRule.travelFromDate, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        travelToDate: momentService.of(exclusionRule.travelToDate, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        travelStartTime: momentService.of(exclusionRule.travelStartTime, momentService.FIELD.FARE_EXCLUSION_RULES_TIME, momentService.FORMAT.TIME_ISO),
        travelEndTime: momentService.of(exclusionRule.travelEndTime, momentService.FIELD.FARE_EXCLUSION_RULES_TIME, momentService.FORMAT.TIME_ISO),
        sellDateFrom: momentService.of(exclusionRule.sellDateFrom, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        sellDateTo: momentService.of(exclusionRule.sellDateTo, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        tripType: exclusionRule.owrtInd,
        tacticalFareType: exclusionRule.tacticalFareType,
        flightPair: exclusionRule.flightPair,
        foOriginRegion: exclusionRule.originRegion,
        foDestRegion: exclusionRule.destinationRegion,
        footnote: exclusionRule.footnote,
        routingId: exclusionRule.routingId,
        effectiveDate: momentService.of(exclusionRule.effectiveDate, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        discontinueDate: momentService.of(exclusionRule.discontinueDate, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        lastUpdatedDate: momentService.of(exclusionRule.lastUpdatedDate, momentService.FIELD.FARE_EXCLUSION_RULES_DATE),
        lastUpdatedBy: exclusionRule.lastUpdatedBy
      };
      result.push(exclusion);
    }
    return result;
  };
  return UserFareExclusionRulesTransformer;
};
UserFareExclusionRulesTransformerFactory.$inject = ['DataTransformerFactory', 'MomentService'];
module.exports = UserFareExclusionRulesTransformerFactory;